import api from './api'

// Flag to use mock data (set to true for development without backend)
const USE_MOCK_DATA = true

// Mock orders storage
let mockOrders = []

export const orderService = {
  // Create new order
  createOrder: async (orderData) => {
    if (USE_MOCK_DATA) {
      // Simulate API delay
      await new Promise(resolve => setTimeout(resolve, 2000))
      
      const newOrder = {
        id: mockOrders.length + 1,
        ...orderData,
        status: 'pending',
        orderNumber: `ORD-${Date.now()}`,
        createdAt: new Date().toISOString(),
        estimatedDelivery: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString() // 7 days from now
      }
      
      mockOrders.push(newOrder)
      
      return newOrder
    }
    
    const response = await api.post('/orders', orderData)
    return response.data
  },

  // Get user orders
  getOrders: async () => {
    if (USE_MOCK_DATA) {
      // Simulate API delay
      await new Promise(resolve => setTimeout(resolve, 500))
      return mockOrders
    }
    
    const response = await api.get('/orders')
    return response.data
  },

  // Get single order
  getOrder: async (id) => {
    if (USE_MOCK_DATA) {
      // Simulate API delay
      await new Promise(resolve => setTimeout(resolve, 300))
      
      const order = mockOrders.find(order => order.id === parseInt(id))
      if (!order) {
        throw new Error('Order not found')
      }
      
      return order
    }
    
    const response = await api.get(`/orders/${id}`)
    return response.data
  },

  // Update order status
  updateOrderStatus: async (id, status) => {
    if (USE_MOCK_DATA) {
      // Simulate API delay
      await new Promise(resolve => setTimeout(resolve, 400))
      
      const orderIndex = mockOrders.findIndex(order => order.id === parseInt(id))
      if (orderIndex === -1) {
        throw new Error('Order not found')
      }
      
      mockOrders[orderIndex].status = status
      return mockOrders[orderIndex]
    }
    
    const response = await api.patch(`/orders/${id}/status`, { status })
    return response.data
  },
}